export default __webpack_public_path__ + "static/underline-25-mobile-6616320cdaa0e57ba89897fa65fc8c25.svg";